// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { __extends } from "tslib";
// THIS FILE WAS AUTOGENERATED
import { EventData } from "/druid/EventData";
/**
 * An instance of PageView represents a generic action on a page like a button click. It is also the base type for PageView.
 */
var PageViewData = /** @class */ (function (_super) {
    __extends(PageViewData, _super);
    function PageViewData() {
        var _this = _super.call(this) || this;
        /**
         * Schema version
         */
        _this.ver = 2;
        /**
         * Collection of custom properties.
         */
        _this.properties = {};
        /**
         * Collection of custom measurements.
         */
        _this.measurements = {};
        return _this;
    }
    return PageViewData;
}(EventData));
export { PageViewData };
//# sourceMappingURL=PageViewData.js.map